import { Button, Modal, ModalBody, ModalFooter, ModalHeader } from '@change/ds-core-ui/next';

import { useSharingModal as useSharingModalContext } from 'src/app/pages/starterDashboardV2/shared/contexts';

import { useSharingModal } from './hooks/useSharingModal';
import type { SharingModalProps } from './types';

/* This is a dummy implementation of the SharingModal component.
 * Replace this with the actual implementation as needed.
 */
export function SharingModal(props: SharingModalProps) {
	const { stopSharingFlow } = useSharingModalContext();
	const {
		data: {
			modalTitle,
			modalDescription,
			primaryCTA,
			secondaryCTA,
			iconComponent,
			nextStepsComponent,
			postPreviewComponent,
		},
		actions: { primaryAction, secondaryAction },
	} = useSharingModal(props);

	const { isOpen } = props;
	return (
		<Modal
			isOpen={isOpen}
			trigger={<Button aria-hidden>Open </Button>}
			isDismissable
			onClose={stopSharingFlow}
			data-testid="sharing-modal"
		>
			<ModalHeader title={modalTitle} subtitle={modalDescription} leadingSlot={iconComponent()} />
			<ModalBody>
				<div className="flex flex-col gap-4 md:flex-row">
					<div className="flex-1">{postPreviewComponent()}</div>
					<div className="flex-1">{nextStepsComponent()}</div>
				</div>
			</ModalBody>
			<ModalFooter>
				<Button onClick={primaryAction} variant="primary">
					{primaryCTA}
				</Button>
				{secondaryAction && <Button onClick={secondaryAction}>{secondaryCTA}</Button>}
			</ModalFooter>
		</Modal>
	);
}
